module.exports = __webpack_public_path__ + "static/media/cmr_11.606f420d.jpg";